import { elysiumTeams } from "./elysium.js";
import { acdFacilitatorIndependentOrg, bexleyLa, bobIndependentOrg, bromleyLa, cqc, cqcTraining, dataControllerCentral, dataControllerNorth, dataControllerSouth, greenwichLa, guysAndStThomasTrust, guysHospital, independentDoctorOrg1, independentDoctorOrg2, independentDoctorOrg3, independentDoctorOrg4, independentDoctorOrg5, independentDoctorOrg6, independentDoctorOrg7, independentDoctorOrg8, independentDoctorOrg9, independentDoctorOrg10, independentDoctorOrg11, independentDoctorOrg12, independentDoctorOrg13, independentDoctorOrg14, independentDoctorOrg15, kingsCollegeHospital, kingsCollegeHospitalTrust, lambethHospital, lambethLa, leadingEdgeHospital, leadingEdgeLocalAuthority, leadingEdgeTrust, lewishamAndGreenwichTrust, lewishamLa, maudsleyHospital, oxleasHouse, oxleasTrust, slamTrust, soad1IndependentOrg, soad2IndependentOrg, southwarkLa, trailingEdgeHospital, trailingEdgeLocalAuthority, trailingEdgeTrust, trainingHospital, trainingIsabellaSoadOrg, trainingLa, universityHospitalLewisham, } from "./organisations.js";
export const teams = {
    id: "04b725da-c048-4690-bb03-d841da38134e",
    organisationId: slamTrust.id,
    name: "SLAM MHA Team",
    type: "mha",
    primaryEmail: "aspire-dev-slam-mha-team@thalamos.co.uk",
    status: "active",
    hasPatientMergeAccess: true,
};
export const oxleasMhaTeam = {
    id: "aab725da-c048-4690-bb03-d841da38134e",
    organisationId: oxleasTrust.id,
    name: "Oxleas MHA Team",
    type: "mha",
    primaryEmail: "aspire-dev-oxleas-mha-team@thalamos.co.uk",
    status: "active",
};
export const lewishamAndGreenwichMhaTeam = {
    id: "bbb725da-c048-4690-bb03-d841da38134e",
    organisationId: lewishamAndGreenwichTrust.id,
    name: "Lewisham and Greenwich MHA Team",
    type: "mha",
    primaryEmail: "aspire-dev-lewisham-and-greenwich-mha-team@thalamos.co.uk",
    status: "active",
};
export const guysAndStThomasMhaTeam = {
    id: "ccb725da-c048-4690-bb03-d841da38134e",
    organisationId: guysAndStThomasTrust.id,
    name: "Guy's and St Thomas's MHA Team",
    type: "mha",
    primaryEmail: "aspire-dev-guys-and-st-thomas-mha-team@thalamos.co.uk",
    status: "active",
};
export const kingsCollegeHospitalMhaTeam = {
    id: "ddb725da-c048-4690-bb03-d841da38134e",
    organisationId: kingsCollegeHospitalTrust.id,
    name: "King's College Hospital MHA Team",
    type: "mha",
    primaryEmail: "aspire-dev-kings-mha-team@thalamos.co.uk",
    status: "active",
};
export const bromleyAmhpTeam = {
    id: "bed83be0-66a0-4725-a720-2ce26a45c2e5",
    organisationId: bromleyLa.id,
    name: "Bromley AMHP Team",
    type: "amhp",
    primaryEmail: "aspire-dev-greater-london-amhp-team@thalamos.co.uk",
    status: "active",
};
export const bexleyAmhpTeam = {
    id: "5767f1d0-ec17-4973-9747-8d5378c0ea0e",
    organisationId: bexleyLa.id,
    name: "Bexley AMHP Team",
    type: "amhp",
    primaryEmail: "aspire-dev-bexley-amhp-team@thalamos.co.uk",
    status: "active",
};
export const greenwichAmhpTeam = {
    id: "aa67f1d0-ec17-4973-9747-8d5378c0ea0e",
    organisationId: greenwichLa.id,
    name: "Greenwich AMHP Team",
    type: "amhp",
    primaryEmail: "aspire-dev-greenwich-amhp-team@thalamos.co.uk",
    status: "active",
};
export const southwarkAmhpTeam = {
    id: "bb67f1d0-ec17-4973-9747-8d5378c0ea0e",
    organisationId: southwarkLa.id,
    name: "Southwark AMHP Team",
    type: "amhp",
    primaryEmail: "aspire-dev-southwark-amhp-team@thalamos.co.uk",
    status: "active",
};
export const lambethAmhpTeam = {
    id: "cc67f1d0-ec17-4973-9747-8d5378c0ea0e",
    organisationId: lambethLa.id,
    name: "Lambeth AMHP Team",
    type: "amhp",
    primaryEmail: "aspire-dev-lambeth-amhp-team@thalamos.co.uk",
    status: "active",
};
export const lewishamAmhpTeam = {
    id: "dd67f1d0-ec17-4973-9747-8d5378c0ea0e",
    organisationId: lewishamLa.id,
    name: "Lewisham AMHP Team",
    type: "amhp",
    primaryEmail: "aspire-dev-lewisham-amhp-team@thalamos.co.uk",
    status: "active",
};
export const lambethWardTeam = {
    id: "27d23722-8b3a-47c2-9eba-f962c9621d18",
    organisationId: lambethHospital.id,
    name: "Lambeth Hospital Ward Team",
    type: "ward",
    primaryEmail: "aspire-dev-lambeth-ward-team@thalamos.co.uk",
    status: "active",
};
export const maudsleyWardTeam = {
    id: "9efd27ae-1937-4e69-a560-1844b8a0e5a5",
    organisationId: maudsleyHospital.id,
    name: "Maudsley Hospital Ward Team",
    type: "ward",
    primaryEmail: "aspire-dev-maudsley-ward-team@thalamos.co.uk",
    status: "active",
};
export const oxleasHouseWardTeam = {
    id: "aafd27ae-1937-4e69-a560-1844b8a0e5a5",
    organisationId: oxleasHouse.id,
    name: "Oxleas House Ward Team",
    type: "ward",
    primaryEmail: "aspire-dev-oxleas-house-ward-team@thalamos.co.uk",
    status: "active",
};
export const universityHospitalLewishamWardTeam = {
    id: "bbfd27ae-1937-4e69-a560-1844b8a0e5a5",
    organisationId: universityHospitalLewisham.id,
    name: "University Hospital Lewisham Ward Team",
    type: "ward",
    primaryEmail: "aspire-dev-university-hospital-lewisham-ward-team@thalamos.co.uk",
    status: "active",
};
export const kingsCollegeHospitalWardTeam = {
    id: "ccfd27ae-1937-4e69-a560-1844b8a0e5a5",
    organisationId: kingsCollegeHospital.id,
    name: "King's College Hospital Ward Team",
    type: "ward",
    primaryEmail: "aspire-dev-kings-college-hospital-ward-team@thalamos.co.uk",
    status: "active",
};
export const guysHospitalWardTeam = {
    id: "ddfd27ae-1937-4e69-a560-1844b8a0e5a5",
    organisationId: guysHospital.id,
    name: "Guy's Hospital Ward Team",
    type: "ward",
    primaryEmail: "aspire-dev-guys-hospital-ward-team@thalamos.co.uk",
    status: "active",
};
export const acdFacilitatorIndependentTeam = {
    id: "a1a31c16-eb0b-473e-aa29-53060ae00d05",
    organisationId: acdFacilitatorIndependentOrg.id,
    name: "Mackenzie ACD Facilitator (Team)",
    type: "independent",
    primaryEmail: "acd.facilitator@aspire.thalamos.co.uk",
    status: "active",
};
export const bobIndependentTeam = {
    id: "263c0efa-de50-4286-afce-2d4575f8110b",
    organisationId: bobIndependentOrg.id,
    name: "Bob Regular Doctor (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+bob.regular.doctor@gmail.com",
    status: "active",
};
// Independent Doctor Teams for S12
export const independentDoctorTeam1 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d80",
    organisationId: independentDoctorOrg1.id,
    name: "Dr. Amara Okafor (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor1@gmail.com",
    status: "active",
};
export const independentDoctorTeam2 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d81",
    organisationId: independentDoctorOrg2.id,
    name: "Dr. James Chen (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor2@gmail.com",
    status: "active",
};
export const independentDoctorTeam3 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d82",
    organisationId: independentDoctorOrg3.id,
    name: "Dr. Sarah Williams (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor3@gmail.com",
    status: "active",
};
export const independentDoctorTeam4 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d83",
    organisationId: independentDoctorOrg4.id,
    name: "Dr. Rajesh Patel (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor4@gmail.com",
    status: "active",
};
export const independentDoctorTeam5 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d84",
    organisationId: independentDoctorOrg5.id,
    name: "Dr. Fatima Al-Rashid (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor5@gmail.com",
    status: "active",
};
export const independentDoctorTeam6 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d85",
    organisationId: independentDoctorOrg6.id,
    name: "Dr. Michael O'Brien (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor6@gmail.com",
    status: "active",
};
export const independentDoctorTeam7 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d86",
    organisationId: independentDoctorOrg7.id,
    name: "Dr. Priya Sharma (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor7@gmail.com",
    status: "active",
};
export const independentDoctorTeam8 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d87",
    organisationId: independentDoctorOrg8.id,
    name: "Dr. David Thompson (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor8@gmail.com",
    status: "active",
};
export const independentDoctorTeam9 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d88",
    organisationId: independentDoctorOrg9.id,
    name: "Dr. Aisha Mohammed (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor9@gmail.com",
    status: "active",
};
export const independentDoctorTeam10 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d89",
    organisationId: independentDoctorOrg10.id,
    name: "Dr. Thomas Anderson (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor10@gmail.com",
    status: "active",
};
export const independentDoctorTeam11 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d90",
    organisationId: independentDoctorOrg11.id,
    name: "Dr. Yuki Tanaka (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor11@gmail.com",
    status: "active",
};
export const independentDoctorTeam12 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d91",
    organisationId: independentDoctorOrg12.id,
    name: "Dr. Elena Rodriguez (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor12@gmail.com",
    status: "active",
};
export const independentDoctorTeam13 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d92",
    organisationId: independentDoctorOrg13.id,
    name: "Dr. Kwame Mensah (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor13@gmail.com",
    status: "active",
};
export const independentDoctorTeam14 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d93",
    organisationId: independentDoctorOrg14.id,
    name: "Dr. Sophie Dubois (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor14@gmail.com",
    status: "active",
};
export const independentDoctorTeam15 = {
    id: "3531b9f3-7f7e-47f9-86f2-210521462d94",
    organisationId: independentDoctorOrg15.id,
    name: "Dr. Ahmed Hassan (Team)",
    type: "independent",
    primaryEmail: "thalamostesting+s12independentdoctor15@gmail.com",
    status: "active",
};
export const soad1IndependentTeam = {
    id: "83d38eee-421d-4ac4-b111-8d44d9fbbf7f",
    organisationId: soad1IndependentOrg.id,
    name: "Knit Soad (Team)",
    type: "soad",
    primaryEmail: "thalamostesting+knit.soad@gmail.com",
    status: "active",
};
export const soad2IndependentTeam = {
    id: "8a05e068-8618-4134-a5b8-9c32efa9b68e",
    organisationId: soad2IndependentOrg.id,
    name: "Purl Soad (Team)",
    type: "soad",
    primaryEmail: "thalamostesting+purl.soad@gmail.com",
    status: "active",
};
export const trainingIsabellaSoadTeam = {
    id: "34352e44-e4ee-417d-9c4e-30f4089174ce",
    organisationId: trainingIsabellaSoadOrg.id,
    name: "Training Isabella Soad (Team)",
    type: "soad",
    primaryEmail: "soad-team-34352e44-e4ee-417d-9c4e-30f4089174ce@aspire.thalamos.co.uk",
    status: "active",
};
export const cqcMainTeam = {
    id: "87602adf-eedb-4daa-948f-b46c0fd37fb3",
    organisationId: cqc.id,
    name: "Care Quality Commission (Thalamos Dev)",
    type: "cqc",
    primaryEmail: "cqc@aspire.thalamos.co.uk", // TODO: fix this
    status: "active",
};
export const cqcTrainingTeam = {
    id: "e474df6b-62d0-44d3-a23d-dc9cca73d953",
    organisationId: cqcTraining.id,
    name: "Care Quality Commission (Training) (Thalamos Dev)",
    type: "cqc",
    primaryEmail: "cqc-training@aspire.thalamos.co.uk", // TODO: fix this
    status: "active",
};
// Training
export const trainingAmhpTeam1 = {
    id: "47295bc3-4e4b-4443-bff4-54c48975e789",
    organisationId: trainingLa.id,
    name: "Training AMHP Team 1",
    type: "amhp",
    primaryEmail: "training.amhp.team1@aspire.thalamos.co.uk",
    status: "active",
};
export const trainingAmhpTeam2 = {
    id: "57992471-391b-4d42-971e-2b6f61a60dee",
    organisationId: trainingLa.id,
    name: "Training AMHP Team 2",
    type: "amhp",
    primaryEmail: "training.amhp.team2@aspire.thalamos.co.uk",
    status: "active",
};
export const trainingWardTeam1 = {
    id: "c0567e29-1c4c-409e-81d3-588f9c880957",
    organisationId: trainingHospital.id,
    name: "Training Ward Team 1",
    type: "ward",
    primaryEmail: "training.ward.team1@aspire.thalamos.co.uk",
    status: "active",
};
export const trainingWardTeam2 = {
    id: "dbc064ad-1832-4df7-920b-9cca4a0f2d8b",
    organisationId: trainingHospital.id,
    name: "Training Ward Team 2",
    type: "ward",
    primaryEmail: "training.ward.team2@aspire.thalamos.co.uk",
    status: "active",
};
export const trainingMhaTeam1 = {
    id: "8aa3ae67-36b9-40bd-9f0e-0b2ba780d928",
    organisationId: trainingHospital.id,
    name: "Training MHA Team 2",
    type: "mha",
    primaryEmail: "training.mha.team1@aspire.thalamos.co.uk",
    status: "active",
};
export const dataControllerNorthTeam = {
    id: "18790316-28a1-4279-a0d1-2b89e27ed6a4",
    organisationId: dataControllerNorth.id,
    name: "Data Controller North Team",
    type: "mha",
    primaryEmail: "aspire-dev-dc-north-team@aspire.thalamos.co.uk",
    status: "active",
};
export const dataControllerCentralTeam = {
    id: "2b46c11a-442e-4d2f-b065-cc2a120f58bc",
    organisationId: dataControllerCentral.id,
    name: "Data Controller Central Team",
    type: "mha",
    primaryEmail: "aspire-dev-dc-central-team@aspire.thalamos.co.uk",
    status: "active",
};
export const dataControllerSouthTeam = {
    id: "391e7b8f-85b4-4a90-9d68-d7465c55c454",
    organisationId: dataControllerSouth.id,
    name: "Data Controller South Team",
    type: "mha",
    primaryEmail: "aspire-dev-dc-south-team@aspire.thalamos.co.uk",
    status: "active",
};
export const leadingEdgeAmhpTeam = {
    id: "720a93ee-9d13-4a17-8158-ccc255329335",
    organisationId: leadingEdgeLocalAuthority.id,
    name: "Leading Edge AMHP Team",
    type: "amhp",
    primaryEmail: "leading-edge-amhp-team@aspire.thalamos.co.uk",
    status: "active",
    hasPatientMergeAccess: true,
};
export const leadingEdgeWardTeam = {
    id: "0f0465a5-2d65-4732-be7d-3ceece17e209",
    organisationId: leadingEdgeHospital.id,
    name: "Leading Edge Ward Team",
    type: "ward",
    primaryEmail: "leading-edge-ward-team@aspire.thalamos.co.uk",
    status: "active",
    hasPatientMergeAccess: true,
};
export const leadingEdgeWardTeam2 = {
    id: "6c1be038-b23c-4d91-a5c5-fa94f82fd156",
    organisationId: leadingEdgeHospital.id,
    name: "Leading Edge Ward Team 2",
    type: "ward",
    primaryEmail: "leading-edge-ward-team-2@aspire.thalamos.co.uk",
    status: "active",
    hasPatientMergeAccess: true,
};
export const leadingEdgeMhaTeam = {
    id: "9dd158cc-d4fe-403d-a915-f592b266751c",
    organisationId: leadingEdgeTrust.id,
    name: "Leading Edge MHA Team",
    type: "mha",
    primaryEmail: "leading-edge-mha-team@aspire.thalamos.co.uk",
    status: "active",
    hasPatientMergeAccess: true,
};
export const trailingEdgeAmhpTeam = {
    id: "59c70038-9daa-4a3c-97db-011f090008d7",
    organisationId: trailingEdgeLocalAuthority.id,
    name: "Trailing Edge AMHP Team",
    type: "amhp",
    primaryEmail: "trailing-edge-amhp-team@aspire.thalamos.co.uk",
    status: "active",
};
export const trailingEdgeWardTeam = {
    id: "1a4d425c-e792-4df0-9a0c-cd8918bc8597",
    organisationId: trailingEdgeHospital.id,
    name: "Trailing Edge Ward Team",
    type: "ward",
    primaryEmail: "trailing-edge-ward-team@aspire.thalamos.co.uk",
    status: "active",
};
export const trailingEdgeMhaTeam = {
    id: "d582939f-b011-475e-b5d5-0cf4269c003d",
    organisationId: trailingEdgeTrust.id,
    name: "Trailing Edge MHA Team",
    type: "mha",
    primaryEmail: "trailing-edge-mha-team@aspire.thalamos.co.uk",
    status: "active",
};
export const bexleyPaymentReviewerTeam = {
    id: "740ef2b1-5897-4d22-9644-e3dc1b26278a",
    organisationId: bexleyLa.id,
    name: "Bexley & SE London Payment Reviewers",
    type: "section-12-payment-reviewers",
    primaryEmail: "bexley-payment-reviewers@aspire.thalamos.co.uk",
    status: "active",
};
export const defaultTeams = [
    maudsleyWardTeam,
    lambethWardTeam,
    bromleyAmhpTeam,
    bexleyAmhpTeam,
    teams,
    bobIndependentTeam,
    independentDoctorTeam1,
    independentDoctorTeam2,
    independentDoctorTeam3,
    independentDoctorTeam4,
    independentDoctorTeam5,
    independentDoctorTeam6,
    independentDoctorTeam7,
    independentDoctorTeam8,
    independentDoctorTeam9,
    independentDoctorTeam10,
    independentDoctorTeam11,
    independentDoctorTeam12,
    independentDoctorTeam13,
    independentDoctorTeam14,
    independentDoctorTeam15,
    acdFacilitatorIndependentTeam,
    greenwichAmhpTeam,
    southwarkAmhpTeam,
    lambethAmhpTeam,
    lewishamAmhpTeam,
    oxleasHouseWardTeam,
    universityHospitalLewishamWardTeam,
    kingsCollegeHospitalWardTeam,
    guysHospitalWardTeam,
    oxleasMhaTeam,
    kingsCollegeHospitalMhaTeam,
    lewishamAndGreenwichMhaTeam,
    guysAndStThomasMhaTeam,
    trainingAmhpTeam1,
    trainingAmhpTeam2,
    trainingWardTeam1,
    trainingWardTeam2,
    trainingMhaTeam1,
    dataControllerNorthTeam,
    dataControllerCentralTeam,
    dataControllerSouthTeam,
    soad1IndependentTeam,
    soad2IndependentTeam,
    trainingIsabellaSoadTeam,
    cqcMainTeam,
    cqcTrainingTeam,
    leadingEdgeAmhpTeam,
    leadingEdgeWardTeam,
    leadingEdgeWardTeam2,
    leadingEdgeMhaTeam,
    trailingEdgeAmhpTeam,
    trailingEdgeWardTeam,
    trailingEdgeMhaTeam,
    bexleyPaymentReviewerTeam,
    ...elysiumTeams,
];
//# sourceMappingURL=teams.js.map